export enum StylesExamplesTabsEnum {
	SX_PROPS = 'SX_PROPS',
	STYLED_COMPONENTS = 'STYLED_COMPONENTS',
	SCSS_STYLES = 'SCSS_STYLES',
}
